import clsx from "clsx";
import {
	BookOpenIcon,
	FileTextIcon,
	HelpCircleIcon,
	VideoIcon,
} from "lucide-react";
import Link from "next/link";
import type React from "react";

interface AnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	href: string;
	children: React.ReactNode;
	className?: string;
}

const Anchor = ({ href, children, className, ...rest }: AnchorProps) => {
	const isVideo = href.includes("/videos/") || href.includes("/video/");
	const isCourse = href.includes("/courses/");
	const isArticle = href.includes("/articles/");
	const isGlossary = href.includes("/glossary/");

	const _Icon = isVideo
		? VideoIcon
		: isArticle
			? FileTextIcon
			: isCourse
				? BookOpenIcon
				: isGlossary
					? HelpCircleIcon
					: null;

	return (
		<Link
			href={href}
			className={clsx(
				"group relative max-w-max items-center gap-1 font-medium text-sky-800 underline underline-offset-2 transition-all visited:text-purple-800 hover:opacity-75 dark:text-sky-200 dark:visited:text-purple-200",
				className,
			)}
			{...rest}
		>
			{children}
		</Link>
	);
};

export default Anchor;
